var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../layout/components/loaders');
var button = require('../components/button');
var dragscroll = require('../libs/dragscroll');
var Model = require('../libs/Model');
var modalForm = require('../layout/components/modalForm');
var session = require('../auth/models/session');
var pathHeader = require('../layout/components/pathHeader');
var documentActions = require('./components/documentActions');
var pageRequestState = require('../layout/components/pageRequestState');

var pointDocument = modalForm(Object.assign(require('../../../../models/documents/Document'), Model));

var dateFormat = 'MM/DD/YYYY';

var attachments = {};

attachments.oninit = function (vnode) {
  var ctrl = this;
  ctrl.equipmentRecord = prop();
  pageRequestState.initialize(ctrl);
  ctrl.getAttachments = function () {
    var url = '/api/v1/equipment/' + m.route.param('id');
    ctrl.equipmentRecord(undefined);
    return pageRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: url,
        method: 'GET'
      })
      .then(function (result) {
        if (!result || !Array.isArray(result.path)) {
          throw new Error('Equipment response is missing its location path.');
        }

        ctrl.equipmentRecord(result);
        ctrl.equipmentRecord().path = result.path.slice().reverse();
        ctrl.fakePath = {'@rid': 1, 'name': 'Documents'};
        ctrl.equipmentRecord().path.push(ctrl.fakePath);
      });
    }, { errorMessage: 'Unable to load documents:' })
    .then(function (result) {
      m.redraw();
      return result;
    });
  };
  ctrl.init = ctrl.getAttachments;
  return ctrl.init();

};

attachments.view = function() {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.equipmentRecord()){
    return m('div');
  }
  return m('div.mh3.mv3', [
    m(pathHeader, {
      ancestors: ctrl.equipmentRecord().path, 
      record: ctrl.fakePath,
    }),
    m('div.mv1', [
      m('div.dragscroll-container', [
        m('div.dragscroll', {oncreate:dragscroll}, [
          m('table.fw2.f3.w-100.pr3', [
            m('thead', [
              m('tr.relative', [
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '30%'}},'Name'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '30%'}},'Description'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Date Uploaded'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Actions')
              ])
            ]),
            m('tbody', [
              (ctrl.equipmentRecord().out_AttachmentOf ||[]).map(function (documentRecord) {
                return m('tr', [
                  m('td.bb.tl.moon-gray.tl.nowrap', documentRecord.in.name),
                  m('td.bb.tl.moon-gray.tl.nowrap',  documentRecord.in.description),
                  m('td.bb.tl.moon-gray.tl.nowrap',  moment(parseInt(documentRecord.in.uploadedDate)).format(dateFormat)),
                  m('td.bb.tl.moon-gray.tl.nowrap', documentActions.renderActions(documentRecord, {
                    submitCallback: ctrl.getAttachments
                  }))
                ])
              })
            ])
          ])
        ])
      ]),
      m('div.cf', [
        session.user().isSuperuser ? m(button,{
            label:'Add Document',
            class: 'w5 mh3 mv4 fr',
            func:  pointDocument.editDialogue.bind(pointDocument, {parent: ctrl.equipmentRecord()['@rid'].slice(1)}, {submitCallback: ctrl.getAttachments}),
          })
        : ''
      ])
    ])
  ])
}

module.exports = attachments;
